import React, {
  ComponentType
} from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { Patient } from '../../patient/patient'

const SafeSegment = Segment as unknown as ComponentType<any>

type PatientRegionProps = {
  patient: Patient | undefined
  mode?: string
}

/**
 * Provides a component that renders the patient region, if provided
 *
 * @param patient Patient entity
 * @param mode Render mode. Default: left
 */
function PatientRegion(
  props: PatientRegionProps
): JSX.Element | null {
  const {
    patient,
    mode: modeProp
  } = props

  const mode = modeProp || 'left'

  const renderLeft = (
    patientData: Patient | undefined
  ): JSX.Element | null => {
    if (patientData && patientData.regionName) {
      return (
        <SafeSegment
          attached
          compact
          className="left-segment"
        >
          <div className="left-title">Patient Region:</div>
          <div className="left-content">{ patientData.regionName }</div>
        </SafeSegment>
      )
    }
    return null
  }

  if (mode === 'left') {
    return renderLeft(patient)
  }
  return null
}

export default PatientRegion
